module.exports = __webpack_public_path__ + "media/images/logo/stokrotka-b8af301f0723a57b513569295a45d6cf.png";